import { Tooltip, TooltipProps } from "@mui/material";
import "./PortalTooltip.css";

export type MUITooltipPlacement = TooltipProps["placement"];

interface Props {
	children: React.ReactElement<any, any>;
	title: React.ReactNode;
	placement?: MUITooltipPlacement;
}

export default function PortalTooltip({ children, title, placement }: Props) {
	return (
		<Tooltip placement={placement} title={title} classes={{ popper: "portal-tooltip" }}>
			{children}
		</Tooltip>
	);
}
